import img1 from '../../media/gallery/50039.jpeg';
import img2 from '../../media/gallery/50002.JPEG';
import img3 from '../../media/gallery/50003.JPEG';
import img4 from '../../media/gallery/50004.JPEG';
import img5 from '../../media/gallery/50005.JPEG';
import img6 from '../../media/gallery/50006.JPEG';
import img7 from '../../media/gallery/50007.JPEG';
import img8 from '../../media/gallery/50008.JPEG';
import img9 from '../../media/gallery/50009.JPEG';
import img10 from '../../media/gallery/50010.JPEG';
import img11 from '../../media/gallery/50011.jpg';
import img12 from '../../media/gallery/50012.JPEG';
import img13 from '../../media/gallery/50013.JPEG';
import img14 from '../../media/gallery/50014.JPEG';
import img15 from '../../media/gallery/50015.JPEG';
import img16 from '../../media/gallery/50016.jpg';
import img17 from '../../media/gallery/50017.JPEG';
import img18 from '../../media/gallery/50018.JPEG';
import img19 from '../../media/gallery/50019.JPEG';
import img20 from '../../media/gallery/50020.JPEG';
import img21 from '../../media/gallery/50021.JPEG';
import img22 from '../../media/gallery/50022.JPEG';
import img23 from '../../media/gallery/50023.JPEG';
import img24 from '../../media/gallery/50024.jpg';
import img25 from '../../media/gallery/50025.JPEG';
import img26 from '../../media/gallery/50026.JPEG';
import img27 from '../../media/gallery/50027.JPEG';
import img28 from '../../media/gallery/50028.jpg';
import img29 from '../../media/gallery/50029.jpg';
import img30 from '../../media/gallery/50030.JPEG';
import img31 from '../../media/gallery/50031.JPEG';
import img32 from '../../media/gallery/50032.JPEG';
import img33 from '../../media/gallery/50033.JPEG';
import img34 from '../../media/gallery/50034.JPEG';
import img35 from '../../media/gallery/50035.JPEG';
import img37 from '../../media/gallery/50037.JPEG';
import img38 from '../../media/gallery/50038.JPEG';
import img39 from '../../media/gallery/50039.jpeg';
import img40 from '../../media/gallery/50040.jpeg';
import img41 from '../../media/gallery/50041.JPEG';
import img42 from '../../media/gallery/50042.jpeg';
import img43 from '../../media/gallery/50043.jpeg';
import img44 from '../../media/gallery/50044.jpeg';
import img45 from '../../media/gallery/50045.jpeg';
import img46 from '../../media/gallery/50046.jpeg';
import img47 from '../../media/gallery/50047.jpeg';
import img49 from '../../media/gallery/50049.jpeg';
import img50 from '../../media/gallery/50050.jpeg';
import img51 from '../../media/gallery/50051.jpeg';
import img52 from '../../media/gallery/50052.jpeg';
import img53 from '../../media/gallery/50053.jpeg';
export default [
  






  img2  ,
  img3  ,
  img4  ,
  img5  ,
  img29 ,
  img30 ,
  img31 ,
  img33 ,
  img34 ,
  img35 ,
  
  img6  ,
  img32 ,
  img8  ,
  img9  ,
  img10 ,
  img11 ,
  img12 ,
  img13 ,
  img14 ,
  img15 ,
  
  img46 ,
  img16 ,
  img17 ,
  img18 ,
  img19 ,
  img20 ,
  img21 ,
  img22 ,
  img23 ,
  img24 ,
  
  img1  ,
  img25 ,
  img27 ,
  img7  ,
  img28 ,
  img37 ,
  img38 ,
  img40 ,
  
  img42 ,
  img43 ,
  img44 ,
  img45 ,
  img47 ,
  img49 ,
  img50 ,
  img51 ,
  img52 ,
  img53 




];
  

